import { FaWhatsapp } from "react-icons/fa";
import { getWhatsappLink } from "../utils/links";

export const FloatingWhatsappButton = ({ message, onClick, phone }) => {
  const href = getWhatsappLink(phone, message);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 text-white rounded-full p-4 shadow-lg hover:bg-green-600 transition-colors duration-300"
      onClick={onClick}
    >
      <FaWhatsapp size={24} />
    </a>
  );
};